import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  portalId: string;
  userId: number;
};

const [useRemovePortalMember, removePortalMember] = createAsyncAction(
  "portalMembers/remove",
  async ({ portalId, userId }: Args) => {
    const res = await API.call<{ member: string }>({
      endpoint: `portals/${portalId}/members/${userId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.member };
  }
);

export default useRemovePortalMember;
export { removePortalMember };
